import { action } from "satcheljs";
import type { AppPaneName } from "owa-app-pane-group-types";
import type { AppPaneActionMessage } from "../types/AppPaneActionMessage";

export const onCloseAppPane: (appPaneName: AppPaneName, targetWindow?: Window) => AppPaneActionMessage = action("onCloseAppPane", (appPaneName: AppPaneName, targetWindow: Window = window): AppPaneActionMessage => ({
    appPaneName,
    targetWindow,
}));
